<template>
  <th class="px-4 py-2 font-medium text-sm whitespace-nowrap border border-gray-400">
    <span>
      {{ notificationChannel.name }}
    </span>

    <portal :to="`channel:${notificationChannel.code}`">
      <input type="checkbox" v-model="selectAll" :disabled="disabled" />
    </portal>
  </th>
</template>

<script>
export default {
  name: 'TableHeaderColumn',
  props: {
    notificationChannel: { type: Object, required: true },
    userNotificationSettings: { type: Array, default: () => [] },
    disabled: Boolean,
  },
  computed: {
    filtered() {
      return this.userNotificationSettings.filter(
        (x) => x.notificationChannelCode === this.notificationChannel.code
      );
    },
    selected() {
      return this.filtered.filter((x) => x.isEnabled);
    },
    selectAll: {
      get() {
        return this.selected.length === this.filtered.length;
      },
      set(select) {
        this.filtered.forEach((item) => {
          // eslint-disable-next-line no-param-reassign
          item.isEnabled = select;
        });
      },
    },
  },
};
</script>
